import { download } from 'features/slides/utils';
import React, { createContext, useState, ReactNode, useContext } from 'react';
// import { downloadPdfSlides } from '../utils';
// import { download } from '../download';

interface SlidesUIContextType {
  zoom: number;
  setZoom: (zoom: number) => void;
  dirty: boolean;
  setDirty: (dirty: boolean) => void;
  isSaving: boolean;
  setIsSaving: (isSaving: boolean) => void;
  isDownloading: boolean;
  handleDownload: (filename: string) => void;
  type: 'premium_report' | 'presentation_of_options';
}

export const SlidesUIContext = createContext<SlidesUIContextType | undefined>(
  undefined,
);

export const SlidesUIProvider = ({
  children,
  type,
}: {
  children: ReactNode;
  type: 'premium_report' | 'presentation_of_options';
}): React.ReactElement => {
  const [dirty, setDirty] = useState(false);
  const [zoom, setZoom] = useState(100);
  const [isSaving, setIsSaving] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async (filename: string) => {
    try {
      setIsDownloading(true);
      const slides = Array.from(
        document.querySelectorAll('#slides-nav-panel .slide-item'),
      ) as HTMLElement[];

      // TODO: Decomment this when want to use new system of reporting generation with Puppeteer in user-ms
      // const styles = Array.from(
      //   document.querySelectorAll(
      //     'style, link[rel="stylesheet"]',
      //   ),
      // )
      //   .map(el => el.outerHTML)
      //   .join('');

      if (type === 'premium_report') {
        // await downloadPdfSlides(slides, filename, 816, 1056);
        await download({
          filename,
          slides,
          width: 816,
          height: 1056,
        });
        // await downloadPdfSlidesRemote(slides, styles, filename, 816, 1056); // TODO: Decomment this when want to use new system of reporting generation with Puppeteer in user-ms
      } else {
        // await downloadPdfSlides(slides, filename, 1280, 720);
        await download({
          filename,
          slides,
        });
        // await downloadPdfSlidesRemote(slides, styles, filename, 1280, 720); // TODO: Decomment this when want to use new system of reporting generation with Puppeteer in user-ms
      }
    } catch (error) {
      console.error('error', error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <SlidesUIContext.Provider
      value={{
        dirty,
        setDirty,
        zoom,
        setZoom,
        handleDownload,
        isSaving,
        setIsSaving,
        isDownloading,
        type,
      }}
    >
      {children}
    </SlidesUIContext.Provider>
  );
};

export const useSlidesUI = (): SlidesUIContextType => {
  const context = useContext(SlidesUIContext);
  if (!context) {
    throw new Error('useSlidesUI must be used within a SlidesUIProvider');
  }
  return context;
};
